module.exports = __webpack_public_path__ + "img/visa-1kpx.c68088d5.png";